import { useEffect, useMemo, useState } from "react";
import { listBingoCategories, type BingoCategoryPublic } from "@hitster/shared";

interface Props {
  category: BingoCategoryPublic;
  roundNumber: number;
}

export function BingoCategoryReveal({ category, roundNumber }: Props) {
  const pool = useMemo(() => listBingoCategories(), []);
  const [shown, setShown] = useState<BingoCategoryPublic>(category);
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    setLocked(false);
    let i = 0;
    const id = window.setInterval(() => {
      i += 1;
      setShown(pool[i % pool.length]!);
      if (i >= 12) {
        window.clearInterval(id);
        setShown(category);
        setLocked(true);
      }
    }, 90);
    return () => window.clearInterval(id);
  }, [category.id, category.icon, category.name, category.color, pool, roundNumber]);

  return (
    <div className="cw-panel p-6 sm:p-10 text-center space-y-4 reveal-pop">
      <p className="text-sm text-violet-400 uppercase tracking-widest">Manche {roundNumber}</p>
      <p className="text-lg text-orange-300">🎱 Tirage…</p>
      <div
        className={`rounded-2xl px-4 py-8 border ${locked ? "bingo-category-land" : ""}`}
        style={{ borderColor: `${shown.color}88`, background: `${shown.color}22` }}
      >
        <p className="text-5xl sm:text-6xl" aria-hidden>
          {shown.icon}
        </p>
        <h2 className="cw-title text-3xl sm:text-5xl font-extrabold mt-3" style={{ color: shown.color }}>
          {shown.name}
        </h2>
      </div>
    </div>
  );
}
